export default {"src":"/_next/static/media/products-digitalproducts.f198a158.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};